import styled from 'styled-components';

export const EntityDetailsWrapper = styled.div`
  display: flex;
`;

export const EntityDetailsHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
